import { Frame } from 'dragonmouse-shared/interfaces';
import { updateGuestFrames } from '../../redux/db/actions';
import store from '../../redux/store';
import { VITE_FORGE_URL } from '../../constants';
import { FrameRow } from '../types';
import { parsePostgresDate, processFrameEntries } from '../util';
import { Stream } from './Stream';
import { v4 as uuid } from 'uuid';

export class GuestFramesStream extends Stream<FrameRow> {
	constructor(userId: string) {
		const url = VITE_FORGE_URL + '/electric/guest-frames';
		const params = {
			userId,
			shapeBust: uuid(),
		};

		const onError = (error: Error) => {
			console.error('Guest frames stream error:', error);
			store.dispatch(updateGuestFrames([]));
		};

		super(url, params, onError, 'guest.frames');
	}

	onShapeData(rows: FrameRow[]) {
		const frames: Frame[] = rows.map((frameRow) => ({
			id: frameRow.id,
			sceneId: frameRow.scene_id,
			title: frameRow.title,
			x: frameRow.x,
			y: frameRow.y,
			width: frameRow.width,
			height: frameRow.height,
			imagePath: frameRow.image_path,
			siteId: frameRow.site_id,
			entries: frameRow.entries ? processFrameEntries(frameRow.entries) : undefined,
			metadata: frameRow.metadata,
			createdAt: parsePostgresDate(frameRow.created_at),
			deletedAt: frameRow.deleted_at ? parsePostgresDate(frameRow.deleted_at) : null,
			writeId: frameRow.write_id,
			viewOnly: true,
		}));
		store.dispatch(updateGuestFrames(frames));
	}

	onStreamMessages(_messages: Array<unknown>) {
		// No optimistic updates needed for guest frames (read-only)
	}
}
